import { render, staticRenderFns } from "./SeriesAddUpdate.vue?vue&type=template&id=35560b9d&scoped=true&"
import script from "./SeriesAddUpdate.vue?vue&type=script&lang=js&"
export * from "./SeriesAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35560b9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35560b9d')) {
      api.createRecord('35560b9d', component.options)
    } else {
      api.reload('35560b9d', component.options)
    }
    module.hot.accept("./SeriesAddUpdate.vue?vue&type=template&id=35560b9d&scoped=true&", function () {
      api.rerender('35560b9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Series/SeriesAddUpdate.vue"
export default component.exports